<script setup lang="ts">
import { ref } from 'vue';
import { MEDICARE_STATUSES } from '@hfc/common/src/types/MedicareStatuses';
import QuestionButtonSet from '@/application/shared/infrastructure/components/questionTypes/QuestionButtonSet.vue';

const model = defineModel<MEDICARE_STATUSES>();

const eligibleMedicare = ref(model.value);

const emitChange = (value?: string): void => {
  model.value = value as MEDICARE_STATUSES;
};

const eligibleMedicareOptions = [{
  text: 'No',
  value: MEDICARE_STATUSES.NOT_ELIGIBLE
}, {
  text: 'Eligible',
  value: MEDICARE_STATUSES.ELIGIBLE
}, {
  text: 'Enrolled',
  value: MEDICARE_STATUSES.ENROLLED
}];
</script>
<template>
  <QuestionButtonSet :options="eligibleMedicareOptions" @update:model-value="emitChange" v-model="eligibleMedicare" id="eligible_medicare" question-text="Is this person currently eligible and/or enrolled in medicare coverage?" :compact-mode="true" />
</template>
